import { render, staticRenderFns } from "./my-cash-fail.vue?vue&type=template&id=10988026&scoped=true&"
import script from "./my-cash-fail.vue?vue&type=script&lang=js&"
export * from "./my-cash-fail.vue?vue&type=script&lang=js&"
import style0 from "./my-cash-fail.vue?vue&type=style&index=0&id=10988026&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10988026",
  null
  
)

export default component.exports